<template>
  <div class="plan-list">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :current="page"

    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType!==2">
            <label>业务机构名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList" @on-change="handleChangeStore"></storeListSelect>
          </div>
          <div class="queryItem storeSelect">
            <label>库存组织:</label>
            <lk-select class="item" v-model="query.warehouseIdList" clearable multiple>
              <lk-option v-for="item in warehouseList" :value="item.id" :key="item.id">
              {{ item.warehouseName }}
              </lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>起止时间:</label>
            <timeStampDatePicker type='daterange' placeholder=" 请选择" class="item" v-model.trim='query.timeRange' ></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <goodsSearchItem labelString="商品搜索" v-model="query.nameMix"></goodsSearchItem>
          </div>

          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch(false)">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <exportAsync  class="btn" @on-click='handleExport' v-if="handlePermission('financeBizReportExport')"></exportAsync>
        <!-- <div class="Report-total-container">
          <div class="Report-total-title">合计</div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">期初数量:</div>
            <div class="Report-total-item-value">{{total.startInventoryNumStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">期初金额:</div>
            <div class="Report-total-item-value">{{total.startInventoryAmountWithoutTaxStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">采购入库数量:</div>
            <div class="Report-total-item-value">{{total.reportBizFinance.purchaseNumStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">采购入库金额:</div>
            <div class="Report-total-item-value">{{total.reportBizFinance.purchaseAmountWithoutTaxStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">采购退货数量:</div>
            <div class="Report-total-item-value">{{total.reportBizFinance.purchaseRefundNumStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">采购退货金额:</div>
            <div class="Report-total-item-value">{{total.reportBizFinance.purchaseRefundAmountWithoutTaxStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">其他入库数量:</div>
            <div class="Report-total-item-value">{{total.reportBizFinance.otherInNumStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">其他入库金额:</div>
            <div class="Report-total-item-value">{{total.reportBizFinance.otherInAmountWithoutTaxStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">入库合计数量:</div>
            <div class="Report-total-item-value">{{total.reportBizFinance.totalInNumStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">入库合计金额:</div>
            <div class="Report-total-item-value">{{total.reportBizFinance.totalInAmountWithoutTaxStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">销售出库数量:</div>
            <div class="Report-total-item-value">{{total.reportBizFinance.saleNumStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">销售出库金额:</div>
            <div class="Report-total-item-value">{{total.reportBizFinance.saleAmountWithoutTaxStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">销售退货数量:</div>
            <div class="Report-total-item-value">{{total.reportBizFinance.saleRefundNumStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">销售退货金额:</div>
            <div class="Report-total-item-value">{{total.reportBizFinance.saleRefundAmountWithoutTaxStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">其他出库数量:</div>
            <div class="Report-total-item-value">{{total.reportBizFinance.otherOutNumStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">其他出库金额:</div>
            <div class="Report-total-item-value">{{total.reportBizFinance.otherOutAmountWithoutTaxStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">出库合计数量:</div>
            <div class="Report-total-item-value">{{total.reportBizFinance.totalOutNumStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">出库合计金额:</div>
            <div class="Report-total-item-value">{{total.reportBizFinance.totalOutAmountWithoutTaxStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">期末数量:</div>
            <div class="Report-total-item-value">{{total.endInventoryNumStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">期末金额:</div>
            <div class="Report-total-item-value">{{total.endInventoryAmountWithoutTaxStr}}</div>
          </div>
        </div> -->
        <lk-table
          border
          :columns='columns'
          :data='tableData'
          ></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import reportService from '@/services/report';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import exportAsync from '../../components/report/ExportAsync.vue';
import inventory from '../../services/inventory';

export default {
  name: 'financeBizReportList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame, exportAsync,
  },
  data() {
    return {
      query: {
        timeRange: [utils.getCurrentMonthTimestamp(), utils.getNextMonthTimestamp()],
        storeIdList: [],
        warehouseList: [],
        nameMix: '',
      },
      // total: { reportBizFinance: {} },
      columns: [
        {
          title: '所属药房',
          key: 'goodsStoreVoStoreName',
          minWidth: 116,
          maxHeight: 60,
        },
        {
          title: '序号',
          minWidth: 60,
          render: (h, { index }) => h('div', index + 1),
        },
        {
          title: '商品编码',
          key: 'goodsStoreVoGoodsSerialCode',
          minWidth: 116,
        },
        {
          title: '商品通用名',
          key: 'goodsStoreVoGoodsApprovedName',
          minWidth: 116,
        },
        {
          title: '规格',
          key: 'goodsStoreVoSpec',
          minWidth: 116,
        },
        {
          title: '单位',
          key: 'goodsStoreVoMinPkgUnitName',
          minWidth: 116,
        },
        {
          title: '物料类别',
          key: 'goodsStoreVoType',
          minWidth: 116,
        },
        {
          title: '期初单位成本',
          key: 'startInventoryCostPriceStr',
          minWidth: 116,
        },
        {
          title: '期初数量',
          key: 'startInventoryNumStr',
          minWidth: 116,
        },
        {
          title: '期初金额',
          key: 'startInventoryAmountWithoutTaxStr',
          minWidth: 116,
        },
        {
          title: '入库',
          align: 'center',
          minWidth: 116,
          children: [
            {
              title: '采购入库数量',
              key: 'reportBizFinancePurchaseNumStr',
              minWidth: 116,
            },
            {
              title: '采购入库金额',
              key: 'reportBizFinancePurchaseAmountWithoutTaxStr',
              minWidth: 116,
            },
            {
              title: '采购退货数量',
              key: 'reportBizFinancePurchaseRefundNumStr',
              minWidth: 116,
            },
            {
              title: '采购退货金额',
              key: 'reportBizFinancePurchaseRefundAmountWithoutTaxStr',
              minWidth: 116,
            },
            {
              title: '其他入库数量',
              key: 'reportBizFinanceOtherInNumStr',
              minWidth: 116,
            },
            {
              title: '其他入库金额',
              key: 'reportBizFinanceOtherInAmountWithoutTaxStr',
              minWidth: 116,
            },
            {
              title: '入库合计数量',
              key: 'reportBizFinanceTotalInNumStr',
              minWidth: 116,
            },
            {
              title: '入库合计金额',
              key: 'reportBizFinanceTotalInAmountWithoutTaxStr',
              minWidth: 116,
            },
          ],
        },
        {
          title: '出库',
          align: 'center',
          minWidth: 116,
          children: [
            {
              title: '销售出库数量',
              key: 'reportBizFinanceSaleNumStr',
              minWidth: 116,
            },
            {
              title: '销售出库金额',
              key: 'reportBizFinanceSaleAmountWithoutTaxStr',
              minWidth: 116,
            },
            {
              title: '销售退货数量',
              key: 'reportBizFinanceSaleRefundNumStr',
              minWidth: 116,
            },
            {
              title: '销售退货金额',
              key: 'reportBizFinanceSaleRefundAmountWithoutTaxStr',
              minWidth: 116,
            },
            {
              title: '其他出库数量',
              key: 'reportBizFinanceOtherOutNumStr',
              minWidth: 116,
            },
            {
              title: '其他出库金额',
              key: 'reportBizFinanceOtherOutAmountWithoutTaxStr',
              minWidth: 116,
            },
            {
              title: '出库合计数量',
              key: 'reportBizFinanceTotalOutNumStr',
              minWidth: 116,
            },
            {
              title: '出库单位成本',
              key: 'reportBizFinanceTotalOutCostPriceStr',
              minWidth: 116,
            },
            {
              title: '出库合计金额',
              key: 'reportBizFinanceTotalOutAmountWithoutTaxStr',
              minWidth: 116,
            },
          ],
        },
        {
          title: '调整金额',
          key: 'adjustAmount',
          minWidth: 116,
        },
        {
          title: '计算期末数量',
          key: 'countEndNumStr',
          minWidth: 116,
        },
        {
          title: '计算期末金额',
          key: 'countEndAmountStr',
          minWidth: 116,
        },
        {
          title: '期末单位成本',
          key: 'endInventoryCostPriceStr',
          minWidth: 116,
        },
        {
          title: '库存期末数量',
          key: 'endInventoryNumStr',
          minWidth: 116,
        },
        {
          title: '库存期末金额',
          key: 'endInventoryAmountWithoutTaxStr',
          minWidth: 116,
        },
      ],
      tableData: [],
      warehouseList: [],

    };
  },
  methods: {

    paramsChange() {
      if (this.params.timeRange && this.params.timeRange.length === 2) {
        this.params.startTime = this.params.timeRange[0];
        this.params.endTime = this.params.timeRange[1];
      }
    },
    handleChangeStore(storeIds) {
      this.getWarehouseList(storeIds);
    },
    getWarehouseList(storeListIds = []) {
      const warehouseIdList = this.query.warehouseIdList;
      this.query.warehouseIdList = [];
      inventory.warehouseList({ storeIds: storeListIds, status: 1 })
        .then((res) => {
          if (res.data.status === 200) {
            this.warehouseList = res.data.data.list;

            // 先选中了A门店，并且选中了该门店下的a仓库，接着选中了B门店，a仓库正常保留，此时清空A门店，a仓库被清空
            const lastWarehouseIndex = this.warehouseList.findIndex(item => item.id === warehouseIdList);
            if (lastWarehouseIndex !== -1 && storeListIds.length) {
              this.query.warehouseIdList = warehouseIdList;
            }
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          console.log(err);
          utils.handleError(err);
        });
    },
    handleExport(info, func) {
      this.paramsChange();
      this.$store.commit('setDisableLoading', true);
      reportService.financeBizReportExport(utils.deletePageAndSize(this.params))
        .then((res) => {
          if (res.data.status === 200) {
            func(res.data.data);
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          console.log(err);
          utils.handleError(err);
        });
    },
    // getTotal() {
    //   this.paramsChange();
    //   reportService.getPurchaseSaleInventoryTotal(utils.deletePageAndSize(this.params)).then((res) => {
    //     if (res.data.status === 200) {
    //       this.total = res.data.data || { reportBizFinance: {} };
    //       console.log(this.total);
    //     } else {
    //       this.$Message.error(res.data.error);
    //     }
    //   }).catch((err) => {
    //     console.log(err);
    //     utils.handleError(err);
    //   });
    // },
    clear() {
      this.query = {
        timeRange: [utils.getCurrentMonthTimestamp(), utils.getNextMonthTimestamp()],
        storeIdList: [],
        warehouseList: [],
        nameMix: '',
      };
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      this.paramsChange();

      reportService.getPurchaseSaleInventoryList(this.params).then((res) => {
        if (res.data.status === 200 && res.data.data.list) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            this.tableData.push(result);
          });
        } else if (res.data.error) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        console.log(err);
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.getWarehouseList();
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
  .btn{
    margin-bottom: 12px
  }
</style>
